<section class="flex items-center w-full gap-4 bg-transparent" [ngClass]="gapOption()">
    @for (option of options(); track $index) {
        <button
            class="flex items-center gap-1 option shrink-0"
            [ngClass]="value() === option.value ? optionActiveStyle() : optionStyle()"
            (click)="handleClick(option)"
        >
            <p [class.active]="value() === option.value" [ngClass]="paddingStyle()">
                {{ option.value | lowercase | translate }}
            </p>

            @if (option.count) {
                <p
                    class="flex items-center justify-center px-2 text-sm rounded-full aspect-square"
                    [ngClass]="value() === option.value ? ' bg-white text-zinc-900 ' : 'bg-zinc-500 text-zinc-400 '"
                >
                    {{ option.count | number }}
                </p>
            }
        </button>
    }
</section>
